import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-status-chip',
    templateUrl: './status-chip.component.html',
    styleUrls: ['./status-chip.component.scss'],
    standalone: false
})
export class StatusChipComponent {
  @Input() statusName: string = '';
  @Input() translationKey: string = '';
}